import React from 'react';
import { useForm } from 'react-hook-form';
import { CollectionContextContainerProps } from './collectionContextProps';
import { CollectionContextStateValues } from './collectionContextModel';
import { CollectionContextController } from './collectionContextInterface';
import { ChatContainerBaseConfig } from '../../../../../base';

export function createCollectionContextContainer(
    config: ChatContainerBaseConfig,
    controller: CollectionContextController
): React.FC<CollectionContextContainerProps> {
    const {
        context: { useContext },
    } = config;

    return (containerProps) => {
        const context = useContext();

        const form = useForm<CollectionContextStateValues>({
            defaultValues: {
                selectedCollectionId: undefined,
            },
        });

        const values = form.watch();

        const props = controller.useProps(context, {
            form: {
                id: 'collection-context',
                form,
                onSubmit() {
                    // Handle form submission if needed
                },
            },
            values,
            onSelectCollection: containerProps.onSelectCollection,
            onBack: containerProps.onBack,
        });

        return <containerProps.as {...props} />;
    };
}
